<template>
  <component :is="as" :class="classes">
    <slot />
  </component>
</template>

<script setup lang="ts">
const $style = useCssModule()

const props = withDefaults(
  defineProps<{
    as?: string
    crossAxisAlignment?: string
    expand?: boolean | 'horizontal' | 'vertical'
    inline?: boolean
    mainAxisAlignment?: string
  }>(),
  {
    as: 'div',
    crossAxisAlignment: 'start',
    expand: false,
    inline: false,
    mainAxisAlignment: 'start',
  },
)

const classes = {
  [$style.column]: true,
  [$style.inline]: props.inline,
  [$style.expand]: typeof props.expand === 'boolean' && props.expand,
  [$style.expandHorizontal]: props.expand === 'horizontal',
  [$style.expandVertical]: props.expand === 'vertical',
  [$style.mainAxisAlignmentStart]: props.mainAxisAlignment === 'start',
  [$style.mainAxisAlignmentEnd]: props.mainAxisAlignment === 'end',
  [$style.mainAxisAlignmentCenter]: props.mainAxisAlignment === 'center',
  [$style.mainAxisAlignmentSpaceAround]:
    props.mainAxisAlignment === 'spaceAround',
  [$style.mainAxisAlignmentSpaceBetween]:
    props.mainAxisAlignment === 'spaceBetween',
  [$style.mainAxisAlignmentSpaceEvenly]:
    props.mainAxisAlignment === 'spaceEvenly',
  [$style.crossAxisAlignmentStart]: props.crossAxisAlignment === 'start',
  [$style.crossAxisAlignmentEnd]: props.crossAxisAlignment === 'end',
  [$style.crossAxisAlignmentCenter]: props.crossAxisAlignment === 'center',
  [$style.crossAxisAlignmentCenter]: props.crossAxisAlignment === 'center',
}
</script>

<style lang="scss" module>
.column {
  display: flex;
  flex-direction: column;

  &.inline {
    display: inline-flex;
  }

  &.expand {
    width: 100%;
    height: 100%;
  }

  &.expandVertical {
    height: 100%;
  }

  &.expandHorizontal {
    width: 100%;
  }
}

.mainAxisAlignmentStart {
  justify-content: flex-start;
}

.mainAxisAlignmentEnd {
  justify-content: flex-end;
}

.mainAxisAlignmentCenter {
  justify-content: center;
}

.mainAxisAlignmentSpaceAround {
  justify-content: space-around;
}

.mainAxisAlignmentSpaceBetween {
  justify-content: space-between;
}

.mainAxisAlignmentSpaceEvenly {
  justify-content: space-evenly;
}

.crossAxisAlignmentStart {
  align-items: flex-start;
}

.crossAxisAlignmentEnd {
  align-items: flex-end;
}

.crossAxisAlignmentCenter {
  align-items: center;
}
</style>
